<!-- 下拉选择器组件分装 -->
<template>
  <div>
    <el-dialog :title="showTitle" :visible.sync="dialogShow" width="600px" append-to-body :before-close="()=>{handleCallBack()}"
			:close-on-click-modal="false">
    <el-form label-position="right" ref="addForm" label-width="70px" class="postForm">
		<el-form-item label="题目分组:" label-width="110px" class="notBlank">
						<el-cascader style="height: auto;" class="formItem300 el-cascader-menu" size="small"
							:options="treeData" :props="defaultProps" v-model="selectedGroupOptions"
							@change="handleGroupChange">
						</el-cascader>
					</el-form-item>
				    <el-form-item label="教材版本:" label-width="110px" class="notBlank">
						<el-select v-model="bookVersionArr" placeholder="请选择" size="small" class="formItem300" multiple="" filterable>
							<el-option v-for="item in bookVersionDict" :key="item.valuekey" :label="item.textkey"
								:value="item.valuekey">
							</el-option>
						</el-select>
					</el-form-item>
						<el-form-item label="难易度:" label-width="110px" class="notBlank">
						<el-select v-model="addForm.proLevel" placeholder="请选择" size="small" class="formItem150">
							<el-option v-for="item in proLevelDict" :key="item.valuekey" :label="item.textkey"
								:value="item.valuekey">
							</el-option>
						</el-select>
					</el-form-item>
				<el-form-item label="导入word文件:" label-width="150px">
					<el-upload ref="upload" action="" :before-upload="beforeUploadXls" accept="word/doc,word/docx">
						<el-button size="small" type="primary" :loading="uploading" :disabled="uploading">点击上传</el-button>	
  						<div slot="tip" class="el-upload__tip">
							<div style="color:blue;line-height: 25px;">1、只允许上传doc,docx格式</div>
							<div style="color:blue;line-height: 25px;">2、自动跳过错误记录</div>
							<div style="color:blue;line-height: 25px;">3、结果请稍候查询题库列表</div>
							<div><u><span style='text-indent:20px'></span></u></div>
						</div>
					</el-upload>
				</el-form-item>
			</el-form>
      </el-dialog>
  </div>
</template>
  
<script>
export default {
  name: "import-word",
  props: ["templateName","importUrl","showTitle","dialogShow","fromType"],
  data() {
    return {
			treeData: [],
			selectedGroupOptions: [],
			defaultProps: {
				children: "children",
				label: "groupName",
				value: "id",
			},
			uploading:false,
			addForm: {
				gradeId: 0,
				unitId: 0,
				chapterId:0,
				proLevel:0
			},
			bookVersionDict:[],
			bookVersionArr:[],
			proLevelDict:[],
			
    }
  },
  methods: {
		handleGroupChange(value) {
			this.addForm.gradeId = 0
			this.addForm.unitId = 0
			this.addForm.chapterId=0
			if (value.length > 0) {
				this.addForm.gradeId = value[0]
			}
			if (value.length > 1) {
				this.addForm.unitId = value[1]
			}
			if (value.length > 2) {
				this.addForm.chapterId = value[2]
			}
		},
    handleCallBack() {
      this.$emit("callBack", '');
    },
    beforeUploadXls(file) {
			if(this.addForm.chapterId<=0){
				this.$message("请选择题目分组");
				return false;
			}
			if(this.bookVersionArr.length<=0){
				this.$message("请选择教材版本");
				return false;
			}
		   if(this.proLevel<=0){
				this.$message("请选择难易度");
				return false;
			}
			if(this.uploading){
				this.$message("正在处理，请勿操作");
				return false;
			}

			this.uploading=true;
			let formData = new FormData();
			formData.append('file', file);//传文件
			formData.append("gradeId",this.addForm.gradeId)
			formData.append("unitId",this.addForm.unitId)
			formData.append("chapterId",this.addForm.chapterId)
			formData.append("versionIds",this.bookVersionArr.join(","))
			formData.append("proLevel",this.addForm.proLevel)
			this.$axios.post(this.importUrl, formData).then(res => {
				if (res.data.status == 0) {
					this.$message(res.data.data);
				}
				else{
					this.$message(res.data.msg);
				}
       			this.uploading=false
				this.handleCallBack()
			})
			return false;
		},
  },
  async created() {
		this.treeData=await this.getExerciseGroupTreeData(this.fromType)
		this.bookVersionDict = (await this.getDictInfo('bookVersion'))
		this.proLevelDict = (await this.getDictInfo('proLevel'))
	}
}
</script>
  
<style scoped lang="scss">

</style>
  
  